import axios from 'axios';
import { API_PORT, DEPLOYENVIRONMENT, FILE_PORT } from 'apiConfig';

const apiAxios = axios.create({
	// baseURL: `https://${DEPLOYENVIRONMENT}garlicerp.com:5443`,
	baseURL: `https://${DEPLOYENVIRONMENT}api.garlicerp.com:${API_PORT}`,
});

const fileAxios = axios.create({
	// baseURL: `https://${DEPLOYENVIRONMENT}garlicerp.com:16443/lynorg-service/endpoint/filemngt`,
	baseURL: `https://${DEPLOYENVIRONMENT}file.garlicerp.com:${FILE_PORT}`,
});

export { apiAxios, fileAxios };
